import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { motion } from "framer-motion";
import { ArrowLeft, ScanLine } from "lucide-react";
import { useLang } from "../i18n";
import { BrandMark } from "../components/Brand";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function QRLanding() {
  const { t } = useLang();
  const navigate = useNavigate();
  const [url, setUrl] = useState("");

  useEffect(() => {
    setUrl(`${window.location.origin}/parent/phone`);
  }, []);

  const steps = [t("qrStep1"), t("qrStep2"), t("qrStep3")];

  return (
    <div className="min-h-screen bg-[#26422A]" data-testid="qr-page">
      <div className="lf-grain min-h-screen">
        <header className="mx-auto flex max-w-4xl items-center justify-between px-5 py-6">
          <button
            data-testid="back-btn"
            onClick={() => navigate("/")}
            className="flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-bold text-[#FFEEBC] hover:bg-white/10"
          >
            <ArrowLeft className="h-4 w-4" /> {t("back")}
          </button>
          <LanguageSwitcher />
        </header>

        <main className="mx-auto flex max-w-4xl flex-col items-center px-5 pb-16 pt-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <BrandMark size="lg" className="mx-auto mb-4" />
            <h1 className="font-display text-4xl font-black text-[#FFEEBC] sm:text-5xl">
              {t("qrTitle")}
            </h1>
            <p className="mx-auto mt-3 max-w-lg text-base font-medium text-[#FFEEBC]/80">
              {t("qrInstruction")}
            </p>
          </motion.div>

          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.15, type: "spring", stiffness: 160, damping: 16 }}
            className="mt-8 rounded-[2rem] bg-[#FFFFFF] p-6 shadow-2xl"
          >
            {url && (
              <div className="rounded-2xl bg-white p-5" data-testid="qr-code">
                <QRCodeSVG
                  value={url}
                  size={260}
                  fgColor="#26422A"
                  bgColor="#FFFFFF"
                  level="M"
                  includeMargin={false}
                />
              </div>
            )}
            <div className="mt-4 flex items-center justify-center gap-2 text-sm font-bold text-[#26422A]">
              <ScanLine className="h-4 w-4" /> {t("checkInKids")}
            </div>
          </motion.div>

          <div className="mt-8 grid w-full max-w-2xl gap-3 sm:grid-cols-3">
            {steps.map((s, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.25 + i * 0.08 }}
                className="rounded-2xl border border-[#FFEEBC]/20 bg-white/5 p-4"
              >
                <div className="mx-auto mb-2 flex h-9 w-9 items-center justify-center rounded-full bg-[#FFEEBC] font-bold text-[#26422A]">
                  {i + 1}
                </div>
                <div className="text-sm font-medium text-[#FFEEBC]/90">{s}</div>
              </motion.div>
            ))}
          </div>

          <p className="mt-10 text-xs font-bold uppercase tracking-widest text-[#FFEEBC]/50">
            {t("qrPoweredBy")}
          </p>
        </main>
      </div>
    </div>
  );
}
